module.exports = __webpack_public_path__ + "assets/bd2454c2a0307766616398885fe3787e.png";